import { render, staticRenderFns } from "./linehaul-road-list-table.vue?vue&type=template&id=6bc453d8"
import script from "./linehaul-road-list-table.vue?vue&type=script&lang=ts"
export * from "./linehaul-road-list-table.vue?vue&type=script&lang=ts"
import style0 from "./linehaul-road-list-table.vue?vue&type=style&index=0&id=6bc453d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports